import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';

// Pages
import LandingPage from './pages/landing-page';
import Dashboard from './pages/dashboard';
import Login from './pages/login';
import Register from './pages/register';
import ProfileSettings from './pages/profile-settings';
import NotFound from './pages/NotFound';

// Feature Pages
import SalesHub from './pages/sales-hub';
import PurchaseCenter from './pages/purchase-center';
import Banking from './pages/banking';
import ReportsDashboard from './pages/reports-dashboard';
import InvoiceCreation from './pages/invoice-creation';
import ItemsManagement from './pages/items-management';
import TimeTracking from './pages/time-tracking';
import ComplianceCenter from './pages/compliance-center';
import OrganizationSettings from './pages/organization-settings';
import AccountantTools from './pages/accountant-tools';
import SuperAdminPanel from './pages/super-admin-panel';
import DocumentManager from './pages/document-manager';
import TenantConfiguration from './pages/tenant-configuration';
import TaxConfiguration from './pages/tax-configuration';

export default function Routes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile-settings" element={<ProfileSettings />} />

          {/* Feature Routes */}
          <Route path="/sales-hub" element={<SalesHub />} />
          <Route path="/purchase-center" element={<PurchaseCenter />} />
          <Route path="/banking" element={<Banking />} />
          <Route path="/reports-dashboard" element={<ReportsDashboard />} />
          <Route path="/invoice-creation" element={<InvoiceCreation />} />
          <Route path="/items-management" element={<ItemsManagement />} />
          <Route path="/time-tracking" element={<TimeTracking />} />
          <Route path="/compliance-center" element={<ComplianceCenter />} />
          <Route path="/organization-settings" element={<OrganizationSettings />} />
          <Route path="/accountant-tools" element={<AccountantTools />} />
          <Route path="/super-admin-panel" element={<SuperAdminPanel />} />
          <Route path="/document-manager" element={<DocumentManager />} />
          <Route path="/tenant-configuration" element={<TenantConfiguration />} />
          <Route path="/tax-configuration" element={<TaxConfiguration />} />

          {/* 404 Page */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}